import { useEffect } from "react"
import { useLocation, useNavigate } from "react-router-dom"

export default function _404() {

  return (
    <>
      <h2 className="home-top-text">oops, ain't nothin here</h2>
    </>
  )
}
